import React from 'react';

import ManageEntityList from './ManageEntityList';
import CharterRequestDetail from '../Editors/CharterRequestDetail';
import { Route } from 'react-router-dom';
import ClientModal from '../Models/ClientModal';
import entities from '../../utils/entities';
import { useAuth } from '../../Services/AuthContext';


const BidHistory = ({ item, route, headerHeight, parentHeight }) => {
    const [auth] = useAuth();
    const listEntity = auth.role === 'Supplier' ? entities.supplierBidSupplierView : entities.supplierBidClient;

    return <React.Fragment>
        <ManageEntityList item={item} route={route} parentHeight={parentHeight} entity={listEntity} headerHeight={headerHeight} />

        <Route path={route + '/:bidId'} render={() =>
            <ClientModal entity={entities.supplierBid} route={route} itemParam='bidId' >
                <CharterRequestDetail route={route} edit={false} placeBid hideChangeNotice={auth.role === 'Supplier'} />
            </ClientModal>} />
          
    </React.Fragment>

}
export default BidHistory;
